import { render, staticRenderFns } from "./template.pug?vue&type=template&id=3d05a8ff&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./style.sass?vue&type=style&index=0&id=3d05a8ff&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d05a8ff",
  null
  
)

export default component.exports